import { render, staticRenderFns } from "./CreateExamine.vue?vue&type=template&id=1c72240d&scoped=true&"
import script from "./CreateExamine.vue?vue&type=script&lang=js&"
export * from "./CreateExamine.vue?vue&type=script&lang=js&"
import style0 from "./CreateExamine.vue?vue&type=style&index=0&id=1c72240d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72240d",
  null
  
)

export default component.exports